export default function setCategory(category) {
	this._updateSearchResults({
		pageNumber: 1,
		category: category.slug, // safe for future changes
		facets: [],
		priceRange: undefined,
	})
}
